import { checkInspectionImageRequired, Deal } from '~/models/Deal';
import { DealEstimationContext } from '~/models/DealEstimate';
import { DealEstimationHeader } from '~/models/DealEstimationHeader';
import { DealEstimationHistoryContext } from '~/models/DealEstimationHistory';
import {
  DealInspectionReportImage,
  DealCompletionReportImage
} from '~/models/DealReportImage';

export const inEstimationDisabled = (
  deal: Deal,
  estimationContext: DealEstimationContext,
  dealEstimationHistoryContext: DealEstimationHistoryContext,
  inspectionImages: DealInspectionReportImage[],
  isAdmin: boolean
): boolean => {
  // マケプレ案件は反社チェックIDが管理されていないとステータスを進められない
  if (
    deal.companySetting.fromMarket &&
    deal.companySetting.antisocialCheckId === null
  )
    return true;
  // 管理会社・施工会社のどちらかが、申請中の見積りが存在したまま、ステータスを戻した際に申請前の見積りの判定だけだと、進めなくなる（見積作成中ステータスでは申請・申請キャンセル等の操作はできない）ので、既に確定した見積りが存在している場合は、進められるようにする
  if (
    estimationContext.dealConstructions.length === 0 &&
    dealEstimationHistoryContext.dealConstructions.length === 0
  )
    return true;
  // admin権限で見積りの申請や承認は行えないので、draft状態の見積りが存在している場合は進められない
  if (isAdmin && dealEstimationHistoryContext.dealConstructions.length !== 0)
    return true;
  if (deal.inspectionDate == null) {
    if (deal.dealType !== 'repair') return true;
    // 修繕案件で現地調査がある場合は立会日程を登録しないと進められない
    if (deal.conductFieldSurvey && deal.dealType === 'repair') return true;
  }
  // 修繕案件で現地調査希望があり、立会報告画像必須設定の場合は登録しないと進められない
  if (inspectionImages.length === 0 && checkInspectionImageRequired(deal))
    return true;
  return false;
};

export const inConstructionDisabled = (
  deal: Deal,
  estimationContext: DealEstimationContext,
  dealEstimationHistoryContext: DealEstimationHistoryContext,
  estimationRequestHeader: DealEstimationHeader | null,
  inspectionImages: DealInspectionReportImage[],
  completeImages: DealCompletionReportImage[]
): boolean => {
  if (estimationContext.dealConstructions.length === 0) return true;
  if (dealEstimationHistoryContext.dealConstructions.length !== 0) return true;
  if (estimationRequestHeader !== null) return true;
  if (checkInspectionImageRequired(deal) && inspectionImages.length === 0)
    return true;
  return deal.completionReportImageRequired
    ? completeImages.length === 0
    : false;
};
